(function(){
  'use strict';

  var cache = {};
  var state = { product: null, selected: {}, images: [], imgIndex: 0 };

  function money(cents){
    return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function fetchProduct(handle){
    if(cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r){ return r.json(); })
      .then(function(p){ cache[handle] = p; return p; });
  }

  // Find the variant whose options match the current selection across all option positions.
  function matchVariant(){
    var p = state.product;
    if(!p) return null;
    var names = p.options.map(function(o){ return typeof o === 'string' ? o : o.name; });
    return p.variants.filter(function(v){
      return names.every(function(name, i){
        return state.selected[name] === v.options[i];
      });
    })[0] || null;
  }

  function valueAvailable(name, value){
    // available if at least one in-stock variant matches this value AND the other already-chosen values
    var p = state.product;
    var names = p.options.map(function(o){ return typeof o === 'string' ? o : o.name; });
    var idx = names.indexOf(name);
    return p.variants.some(function(v){
      if(v.options[idx] !== value) return false;
      if(!v.available) return false;
      return names.every(function(n, i){
        if(i === idx) return true;
        if(!state.selected[n]) return true; // other option not yet chosen
        return state.selected[n] === v.options[i];
      });
    });
  }

  function imageFor(variant){
    var p = state.product;
    if(variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if(p.featured_image) return p.featured_image;
    if(p.images && p.images[0]) return p.images[0];
    return '';
  }

  function render(){
    var p = state.product;
    var names = p.options.map(function(o){ return typeof o === 'string' ? o : o.name; });
    var optionValues = p.options.map(function(o, i){
      if(typeof o !== 'string') return { name: o.name, values: o.values.map(function(vv){ return typeof vv === 'string' ? vv : vv.name; }) };
      var seen = {}, vals = [];
      p.variants.forEach(function(v){ var val = v.options[i]; if(!seen[val]){ seen[val] = 1; vals.push(val); } });
      return { name: o, values: vals };
    });
    var isDefaultOnly = (names.length === 1 && names[0] === 'Title');
    var variant = matchVariant();
    var images = (state.images && state.images.length) ? state.images : [imageFor(variant)].filter(Boolean);
    if(state.imgIndex >= images.length) state.imgIndex = 0;
    var curImg = images[state.imgIndex] || imageFor(variant);
    var hasGallery = images.length > 1;
    var price = variant ? variant.price : p.price;

    var optionsHtml = isDefaultOnly ? '' : optionValues.map(function(grp){
      var pills = grp.values.map(function(val){
        var avail = valueAvailable(grp.name, val);
        var sel = state.selected[grp.name] === val;
        return '<button type="button" class="qv-pill' + (sel ? ' is-selected' : '') + (avail ? '' : ' is-disabled') + '"'
          + ' data-option="' + esc(grp.name) + '" data-value="' + esc(val) + '"'
          + (avail ? '' : ' disabled') + '>' + esc(val) + '</button>';
      }).join('');
      return '<div class="qv-opt"><span class="qv-opt-label">' + esc(grp.name) + '</span><div class="qv-pills">' + pills + '</div></div>';
    }).join('');

    var canAdd = isDefaultOnly ? (p.variants[0] && p.variants[0].available) : (variant && variant.available);
    var btnLabel = 'Add to Bag';
    if(!isDefaultOnly && names.some(function(n){ return !state.selected[n]; })) btnLabel = 'Select ' + names.filter(function(n){ return !state.selected[n]; }).join(' & ');
    else if(!canAdd) btnLabel = 'Sold Out';

    document.getElementById('qv-inner').innerHTML = ''
      + '<div class="qv-media">'
      +   (hasGallery ? '<button class="gallery-arrow gallery-arrow--prev" data-qv-prev aria-label="Previous image" type="button">&#8249;</button>' : '')
      +   (curImg ? '<img id="qv-img" src="' + esc(curImg) + '" alt="' + esc(p.title) + '">' : '')
      +   (hasGallery ? '<button class="gallery-arrow gallery-arrow--next" data-qv-next aria-label="Next image" type="button">&#8250;</button>' : '')
      +   (hasGallery ? '<div class="gallery-counter">' + (state.imgIndex+1) + ' / ' + images.length + '</div>' : '')
      + '</div>'
      + '<div class="qv-details">'
      +   '<h2 class="qv-title">' + esc(p.title) + '</h2>'
      +   '<div class="qv-price">' + money(price) + '</div>'
      +   optionsHtml
      +   '<button type="button" class="qv-add" id="qv-add"' + (canAdd ? '' : ' disabled') + '>' + esc(btnLabel) + '</button>'
      +   '<a class="qv-full" href="' + esc(p.url) + '">View full details &rarr;</a>'
      + '</div>';

    // re-run the brand decorator on injected text if present
    if(window.pcDecorate) window.pcDecorate(document.getElementById('qv-inner'));
  }

  function open(handle){
    var modal = document.getElementById('qv-modal');
    var overlay = document.getElementById('qv-overlay');
    if(!modal) return;
    document.getElementById('qv-inner').innerHTML = '<div class="qv-loading">Loading&hellip;</div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    if(overlay) overlay.classList.add('is-open');
    document.body.classList.add('drawer-open');

    fetchProduct(handle).then(function(p){
      state.product = p;
      state.selected = {};
      state.images = (p.images || []).slice();
      state.imgIndex = 0;
      var names = p.options.map(function(o){ return typeof o === 'string' ? o : o.name; });
      // auto-select any option that has exactly one value
      names.forEach(function(name, i){
        var vals = {};
        p.variants.forEach(function(v){ vals[v.options[i]] = 1; });
        var keys = Object.keys(vals);
        if(keys.length === 1) state.selected[name] = keys[0];
      });
      render();
    }).catch(function(){
      document.getElementById('qv-inner').innerHTML = '<div class="qv-loading">Could not load product.</div>';
    });
  }

  function close(){
    var modal = document.getElementById('qv-modal');
    var overlay = document.getElementById('qv-overlay');
    if(modal){ modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); }
    if(overlay) overlay.classList.remove('is-open');
    if(!document.querySelector('.cart-drawer.is-open')) document.body.classList.remove('drawer-open');
  }

  document.addEventListener('DOMContentLoaded', function(){
    // Open quick-view from any card add button
    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-pc-quickview]');
      if(!trigger) return;
      e.preventDefault();
      var handle = trigger.dataset.productHandle;
      if(handle) open(handle);
    });

    // Pill selection + add inside the modal (delegated)
    var inner = document.getElementById('qv-inner');
    if(inner){
      inner.addEventListener('click', function(e){
        // gallery arrows
        var prev = e.target.closest('[data-qv-prev]');
        var next = e.target.closest('[data-qv-next]');
        if(prev || next){
          var n = state.images.length;
          if(n > 1){ state.imgIndex = (state.imgIndex + (next ? 1 : -1) + n) % n; render(); }
          return;
        }
        var pill = e.target.closest('.qv-pill');
        if(pill && !pill.disabled){
          state.selected[pill.dataset.option] = pill.dataset.value;
          // when a color is chosen, jump the gallery to that color's first image (faded-aware)
          if(pill.dataset.option === 'Color' && state.images.length){
            var want = (pill.dataset.value || '').toLowerCase();
            var urlColor = function(u){
              u = (u || '').toLowerCase();
              var f = u.indexOf('faded') !== -1;
              if(u.indexOf('grey') !== -1 || u.indexOf('gray') !== -1) return 'grey';
              if(u.indexOf('bone') !== -1) return f ? 'faded bone' : 'bone';
              if(u.indexOf('black') !== -1) return f ? 'faded black' : 'black';
              return null;
            };
            for(var i = 0; i < state.images.length; i++){
              if(urlColor(state.images[i]) === want){ state.imgIndex = i; break; }
            }
          }
          render();
          return;
        }
        var add = e.target.closest('#qv-add');
        if(add && !add.disabled){
          var p = state.product;
          var names = p.options.map(function(o){ return typeof o === 'string' ? o : o.name; });
          var variant = (names.length === 1 && names[0] === 'Title') ? p.variants[0] : matchVariant();
          if(!variant) return;
          add.textContent = 'Adding...';
          add.disabled = true;
          window.PCCart.add(variant.id, 1).then(function(){ close(); }).catch(function(){
            add.textContent = 'Sold Out';
          });
        }
      });
    }

    // swipe on quick-view media (mobile)
    if(inner){
      var qsx = 0, qsy = 0;
      inner.addEventListener('touchstart', function(e){
        if(!e.target.closest('.qv-media')) return;
        qsx = e.touches[0].clientX; qsy = e.touches[0].clientY;
      }, {passive:true});
      inner.addEventListener('touchend', function(e){
        if(!e.target.closest('.qv-media')) return;
        var dx = e.changedTouches[0].clientX - qsx, dy = e.changedTouches[0].clientY - qsy;
        var n = state.images.length;
        if(n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          state.imgIndex = (state.imgIndex + (dx < 0 ? 1 : -1) + n) % n; render();
        }
      }, {passive:true});
    }

    var closeBtn = document.getElementById('qv-close');
    var overlay = document.getElementById('qv-overlay');
    if(closeBtn) closeBtn.addEventListener('click', close);
    if(overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
  });
})();
